
import Vue from 'vue'
import Component from 'vue-class-component'
import PageView from '@/components/page-view.vue'
import { setSStorageInfo } from '@/common'
// import openView from '@/common/open-view'

@Component({
  components: { PageView },
})
export default class IndexView extends Vue {
  needBorder = false

  created() {
    const device = navigator.userAgent
    if (device.includes('iPhone')) {
      setSStorageInfo('infocolectChannel', 4) //IOS
      setSStorageInfo('opSource', 4) //IOS
    } else if (device.includes('Android')) {
      setSStorageInfo('infocolectChannel', 5) //Android
      setSStorageInfo('opSource', 3) //Android
    } else {
      setSStorageInfo('infocolectChannel', 3) //手机
      setSStorageInfo('opSource', 3) //Android
    }
  }
}
